import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import ThreeDots from "static/images/ThreeDots.svg";
import { ArchiveNote } from "./ArchiveNote";
import { useModal } from "hooks/useModal";
import classNames from "classnames";
import { useAuth } from "hooks/useAuth";

export const UnifyNoteOptions = ({
  noteId,
  isArchived,
  handleEdit,
  resetNotes,
  onDropdownOpenChange,
  isDropdownOpen,
  isPinnedNote,
  noteCreatedBy,
}: {
  noteId: string;
  isArchived: boolean;
  handleEdit: (noteId: string) => void;
  resetNotes: () => void;
  onDropdownOpenChange: (isOpen: boolean) => void;
  isDropdownOpen: boolean;
  isPinnedNote: boolean;
  noteCreatedBy: string | undefined;
}) => {
  const archiveModal = useModal();
  const { uuid } = useAuth();
  const canEditNote = uuid === noteCreatedBy;

  return (
    <div
      className={classNames(
        "t-opacity-0 group-hover:t-opacity-100 t-absolute group-hover:t-relative",
        {
          "t-opacity-100 t-relative": isDropdownOpen,
        }
      )}
    >
      <Dropdown.Root onOpenChange={onDropdownOpenChange}>
        <Dropdown.Trigger asChild>
          <div>
            <Button size="small" customType="ghost">
              <img src={ThreeDots} alt="Action" className="t-select-none" />
            </Button>
          </div>
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content
            align="end"
            side="bottom"
            className="!t-max-w-32 !t-min-w-32"
          >
            <Dropdown.Item onSelect={archiveModal.open}>
              {isArchived ? "Unarchive" : "Archive"}
            </Dropdown.Item>
            {!isArchived && canEditNote && (
              <Dropdown.Item onSelect={() => handleEdit(noteId)}>
                Edit
              </Dropdown.Item>
            )}
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
      <ArchiveNote
        {...archiveModal}
        noteId={noteId}
        resetNotes={resetNotes}
        isArchived={isArchived}
        isPinnedNote={isPinnedNote}
      />
    </div>
  );
};
